import { NewtipoCartera } from "../components/Tipo_Cartera/NewtipoCartera";
import Layout from "../components/Layout";

export default function TipoCartera() {

  return (
    <div>
        <Layout />
        <div>
            <NewtipoCartera />
        </div>
    </div>
  );
}